// @ts-nocheck

import React, { memo, useContext, ReactNode, useCallback } from "react";

import { DateFieldProps } from "./DateField.props";
import LabelTextItem from "../../LabelTextItem";
import DateFieldComponent from "./DateField";
import { FormContext, useFormField } from "../../Form";

const DateField: React.FC<DateFieldProps> = (props: DateFieldProps): JSX.Element => {
  const { id, labelText, name, displayReadOnlyFieldInline, readOnly, shouldHide, defaultValue, formatValue = "", isLoading } = props;
  const formContextValues = useContext(FormContext);

  let component = null;

  const fieldValue = useFormField(name || "");

  const shouldHideHandler = useCallback((value: ReactNode): boolean => {
    if (shouldHide) {
      if (value === undefined) return shouldHide(undefined);
      if (typeof value === "string") return shouldHide(value);
    }

    return false;
  }, []);

  if (formContextValues.readOnly || readOnly) {
    const textFieldValue = fieldValue && new Array(String(fieldValue)).filter(Boolean).join("\r\n");

    component = (
      <LabelTextItem
        id={id}
        label={labelText}
        displayInline={displayReadOnlyFieldInline}
        body={textFieldValue || defaultValue}
        isLoading={formContextValues.formState.isFormLoading || isLoading}
        shouldHide={shouldHideHandler}
        className={props?.containerClassName}
        type={"text"}
        formatValue={formatValue}
      />
    );
  } else {
    component = <DateFieldComponent {...props} {...formContextValues} />;
  }

  return component;
};

export default memo(DateField);
